<template>
    <div class="xcard">
        <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
        <h3 class="text-center mt-0 mb-0">Inscripciones Nominal.</h3>
        <form class="xcard mb-0 pb-0" @submit.prevent="validarDatos" style="margin-top:0;background:#E9F2F7;" novalidate>
            <p class="text-center mt-0">
                <small> Filtrar inscripciones por asesor desde una fecha determinada a otra </small>
            </p>
            <div class="row">
                <div class="col-sm-2">
                    <input type="text" class="form-control input-sm" v-model="buscar" placeholder="Buscar en la tabla" />
                    <small>Busqueda rapida</small>
                </div>
                <div class="col-sm-2">
                    <Fecha :model="busqueda" :valueto="'fecha_ini'" :default="busqueda.fecha_ini" />
                    <small>Inscripciones desde</small>
                </div>
                <div class="col-sm-2">
                    <Fecha :model="busqueda" :valueto="'fecha_fin'" :default="busqueda.fecha_fin" />
                    <small>Inscripciones hasta</small>
                </div>
                <div class="col-sm-2">
                    <UsuariosActivos :models="asesorsel" :multiple="false" :xonlyasesores="true" />
                    <small>Usuario asesor</small>
                </div>
                <div class="col-sm-2">
                    <select class="form-control" v-model="programasel">
                        <option value="-1"> Todos </option>
                        <option v-for="(p, ind) in programasbysede" :key="ind" :value="p.id"> {{ p.nombre_compuesto }} </option>
                    </select>
                    <v-progress-linear v-show="cargandoprogras" indeterminate color="light-blue" height="2" value="10" striped></v-progress-linear>
                    <small>Programa de la sede</small>
                </div>

                <div class="col-sm-2">
                    <button class="btn btn-sm btn-azul"><span class="glyphicon glyphicon-search"></span> Buscar</button>
                    <button v-show="false" class="btn btn-sm btn-link" @click="generarReporte()"><span class="glyphicon glyphicon-print"></span> Reporte PDF</button>
                    <button :disabled="$store.state.isonlyread" v-show="inscripciones.length > 0" class="btn btn-sm btn-link" @click="tableToExcel('table', 'Inscritos')"><span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL</button>
                </div>
            </div>
            <p class="text-danger text-center mt-0">{{ msg }}</p>
        </form>

        <div class="text-center">
            <div style="display: inline-block;" v-show="loading" class="loader"></div>
        </div>

        <p v-if="inscripciones.length" class="mb-0 mt-4">
            Se han encontrado: <b>{{ inscripciones.length }}</b> registros de <b>{{ asesorsel.usuarios.nombres }}</b
            >, desde <b>{{ busqueda.fecha_ini }}</b> hasta <b>{{ busqueda.fecha_fin }}</b>
        </p>
        <p v-else-if="inscripciones.length == 0 && buscado" class="text-center red--text">
            No se han encontrado registros de <b>{{ asesorsel.usuarios.nombres }}</b
            >, desde <b>{{ busqueda.fecha_ini }}</b> hasta <b>{{ busqueda.fecha_fin }}</b>
        </p>

        <div class="table-responsivex" v-if="inscripciones.length">
            <table ref="table" class="table-condensed table-striped table-hover" summary="lorem ipsum sit amet" rules="groups" frame="hsides" id="midatatable">
                <caption v-show="false">
                    Reporte de inscripciones:
                    <b>{{ inscripciones.length }}</b>
                    inscripciones de
                    <b>{{ asesorsel.usuarios.nombres }}</b>
                </caption>
                <thead style="background:#196391;">
                    <tr class="white--text">
                        <th>#</th>
                        <th>Estudiante</th>
                        <th stylex="max-width:200px!important">Programa</th>
                        <th>Fecha registro</th>
                        <th>Estado ins.</th>
                        <th></th>
                        <!-- <th>Estado plan</th>
            <th>Estado</th> -->
                    </tr>
                </thead>

                <tbody>
                    <tr v-bind:key="ins.id" v-for="(ins, ind) in inscripciones">
                        <td :title="'ID inscripcion: ' + ins.id">{{ ind + 1 }}</td>
                        <td>{{ ins.estudiante.nombres }} {{ ins.estudiante.primer_apellido }} {{ ins.estudiante.segundo_apellido ? ins.estudiante.segundo_apellido: '' }}</td>
                        <td stylex="max-width:200px!important">{{ ins.programa.nombre_compuesto }}</td>
                        <td>{{ parsefecha(ins.fecha_registro) }}</td>
                        <td :style="parseInsColor(ins.estado_inscripcion)">{{ parseIns(ins.estado_inscripcion) }}</td>
                        <td>
                            <button
                                v-if="ins.estado_inscripcion == 1"
                                type="button" 
                                class="btn btn-sm btn-default"
                                @click="open_expedientes(ins)"
                                title="Expedientes ISPI">
                                <span class="glyphicon glyphicon-floppy-save"></span>
                            </button>
                        </td>
                        <!-- <td> {{ins.estado_plan_id}} </td>
            <td> {{ins.estado}} </td> -->
                    </tr>
                </tbody>
            </table>
        </div>

        <menuExp ref="refmenu" />
    </div>
</template>

<script>
import Fecha from "@/components/AFecha.vue";
import UsuariosActivos from "@/components/AusuariosActivosx";
import { getheadersrest } from "@/components/Utils"; 
import menuExp from '../components/expedientesispi/menu.vue';
import gql from "graphql-tag";

export default {
    data() {
        return {
            // EXCEL
            uri: "data:application/vnd.ms-excel;base64,",
            template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
            base64: function(s) {
                return window.btoa(unescape(encodeURIComponent(s)));
            },
            format: function(s, c) {
                return s.replace(/{(\w+)}/g, function(m, p) {
                    return c[p];
                });
            },
            // END EXCEL
            buscar: "",
            cargandoprogras: false,
            loading: false,
            buscado: false,
            msg: "",
            asesorsel: { usuarios: {} },
            programasel: -1,
            programasbysede: [],
            inscripciones: [],
            busqueda: {
                fecha_ini: null,
                fecha_fin: null,
            },
        };
    },
    components: { Fecha, UsuariosActivos, menuExp },
    watch: {
        buscar: function() {
            this.myFunction1(this.buscar);
        },
        "$store.state.CARGO": function() {
            this.getprogramasbysede();
        },
    },
    methods: {
        myFunction1(filtro) {
            filtro = filtro.toUpperCase();
            var table, tr, tdd, td, i, j, txtValue;
            table = document.getElementById("midatatable");
            tr = table.getElementsByTagName("tr");

            for (i = 0; i < tr.length; i++) {
                tdd = tr[i].getElementsByTagName("td");
                for (j = 1; j < tdd.length; j++) {
                    td = tdd[j];
                    if (td) {
                        txtValue = td.textContent;
                        if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                            tr[i].style.display = "";
                            break;
                        } else {
                            tr[i].style.display = "none";
                        }
                    }
                }
            }
        },
        getFechasDefault() {
            var date = new Date();
            var d = date.getDate();
            var m = date.getMonth() + 1;
            if (d == 1) d = 2;
            if (d < 10) d = "0" + d;
            if (m < 10) m = "0" + m;
            var ini = date.getFullYear() + "-" + m + "-01";
            var fin = date.getFullYear() + "-" + m + "-" + d;
            this.busqueda.fecha_ini = ini;
            this.busqueda.fecha_fin = fin;
        },
        tableToExcel(table, name) {
            if (!table.nodeType) table = this.$refs.table;
            var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
            var link = document.createElement("a");
            link.download = "inscripcionesNominal.xls";
            link.href = this.uri + this.base64(this.format(this.template, ctx));
            link.click();
        },

        parseInsColor(ins) {
            if (ins == 0) return "background:#EFFFA8";
            else if (ins == 1) return "background:#A8FFA8";
            else if (ins == 2) return "background:#D9F0D9";
            else if (ins == 3) return "background:#FFC8A8";
            else if (ins == 4) return "background:#FFEAEA";
            else if (ins == 10) return "background:#FFEAEA";
            else return "";
        },
        parseIns(ins) {
            var str = "";
            if (ins == 0) str = "Pre inscrito";
            else if (ins == 1) str = "Inscrito";
            else if (ins == 2) str = "inscrito+certificacion";
            else if (ins == 3) str = "retirado";
            else if (ins == 4) str = "cambiado";
            else if (ins == 5) str = "congelado";
            else if (ins == 6) str = "pagado-inscripcion";
            else if (ins == 7) str = "pagado";
            else if (ins == 8) str = "no puede pagar";
            else if (ins == 9) str = "Generar plan";
            else if (ins == 10) str = "Por Generar Plan";
            return str;
        },

        getprogramasbysede() {
            this.cargandoprogras = true;
            this.programasel = -1;
            const vue = this;
            let idsede = this.$store.state.CARGO.idsede;
            this.programasbysede = [];
            let gestiontodos = "";
            var sql = gql`query{ getProgramas(cursor:1000000,estado:true,idsede:${idsede},${gestiontodos}){id,nombre_compuesto,postgrado{id,nombre}} }`;
            //window.console.log( 'sql:',sql.loc.source.body );

            this.$apollo
                .query({
                    query: sql,
                    variables: {
                        cursor: this.cursor,
                    },
                })
                .then((data) => {
                    let datos = data.data.getProgramas;
                    datos = datos.sort((a, b) => {
                        return ("" + a.nombre_compuesto.attr).localeCompare(b.nombre_compuesto.attr);
                    });
                    vue.programasbysede = datos;
                    vue.cargandoprogras = false;
                })
                .catch(() => {
                    this.$root.$notify.show("Session Expirada");
                    this.cargandoprogras = false;
                });
        },

        validarDatos() {
            this.msg = "";
            let idasesor = this.asesorsel.usuarios.id;
            //let fechasvalidas = this.busqueda.fecha_ini.length && this.busqueda.fecha_fin.length;
            //window.console.log( "Hola mundo:",idasesor,fechasvalidas,this.busqueda );
            if (!idasesor) {
                this.msg = "Seleccione un asesor.";
            } else {
                this.buscado = false;
                this.inscripciones = [];
                this.buscarinscripciones(idasesor);
            }
        },

        buscarinscripciones(idasesor) {
            let fs1 = this.busqueda.fecha_ini.split("-");
            let fs2 = this.busqueda.fecha_fin.split("-");
            let f1 = `${fs1[2]}/${fs1[1]}/${fs1[0]}`;
            let f2 = `${fs2[2]}/${fs2[1]}/${fs2[0]}`;
            // window.console.log(f1, f2);

            let data = { asesor_id: idasesor, fecha_inicio: f1, fecha_fin: f2 };
            if (this.programasel != -1) data.programa_id = this.programasel;
            if (this) this.loading = true;
            const vue = this;
            let myHeaders = getheadersrest();
            let raw = JSON.stringify(data);
            var requestOptions = { method: "POST", headers: myHeaders, body: raw, redirect: "follow" };

            fetch(process.env.VUE_APP_API_REST + "/api/esam/inscripcion/search", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    // window.console.log( JSON.stringify(result) );
                    if (result) vue.inscripciones = result;
                    else vue.buscado = true;
                    vue.loading = false;
                })
                .catch(() => {
                    vue.msg = "";
                    vue.loading = false;
                });
        },

        parsefecha(f) {
            if (!f) return "-";
            let datos = f.split(" ");
            let fechas = datos[0].split("-");
            let fecha = `${fechas[2]}/${fechas[1]}/${fechas[0]}`;
            return fecha;
        },
        open_expedientes(ins){
            window.console.log(ins);
            this.$refs.refmenu.openmodal(ins);
        },
    },
    mounted() {
        this.getFechasDefault();
        this.getprogramasbysede();
    },
};
</script>
